import { z } from 'zod';
import { Id, IsoDateTime } from './common.js';

export const UserRole = z.enum(['owner', 'admin', 'agent', 'viewer']);
export type UserRole = z.infer<typeof UserRole>;

export const TeamUser = z.object({
  user_id: Id,
  merchant_id: Id,
  clerk_user_id: z.string(),
  email: z.string().email(),
  name: z.string(),
  role: UserRole,
  is_active: z.boolean(),
  fcm_tokens: z.array(z.string()).default([]),
  notification_prefs: z
    .object({
      escalations: z.boolean().default(true),
      new_orders: z.boolean().default(true),
      new_appointments: z.boolean().default(true),
      new_leads: z.boolean().default(true),
      digest_frequency: z.enum(['realtime', 'daily', 'weekly', 'off']).default('daily'),
      mentions: z.boolean().default(true),
    })
    .default({
      escalations: true,
      new_orders: true,
      new_appointments: true,
      new_leads: true,
      digest_frequency: 'daily',
      mentions: true,
    }),
  created_at: IsoDateTime,
});
export type TeamUser = z.infer<typeof TeamUser>;

export const ConversationNote = z.object({
  note_id: Id,
  conversation_id: Id,
  merchant_id: Id,
  user_id: Id,
  body: z.string().max(4000),
  mentions: z.array(Id).default([]),
  created_at: IsoDateTime,
});
